/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class CategoryService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        $log.debug('Service \'CategoryService\' loaded');
    }
}

export { CategoryService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/service/CategoryService.js